// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.league-user-permissions__sections{
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-items: center;
    margin-top: var(--space-x2);
}

.league-user-permissions__container{
    width: 60%;
    background: rgba(255, 255, 255, 1);
    border-radius: 8px;
    padding: 1%;
}

.league-user-permissions__container__championships{
    width: 40%;
    background: rgba(255, 255, 255, 1);
    border-radius: 8px;
    padding: 1%;
    margin-left: 1%
}

.league-user-permissions__title.baloa-subtitle-2{
    color: var(--primary-dark-color) !important;
}
.league-user-permissions__permissions-groups{
    display: flex;
    justify-content: space-between;
    margin-top: var(--space);
}
.league-user-permissions__permission-group{
    background: var(--white-color);
    border: 1px solid var(--disabled-sb-font-color);
    box-sizing: border-box;
    border-radius: 8px;
    height: 100px;
    width: 30%;
    cursor: pointer;
    padding: 7px;
    display: grid;
    justify-content: center;
    align-items: start;
}

.league-user-permissions__permission-group.selected{
    background: var(--white-color);
    border: 2px solid var(--basic-green-color);
    box-sizing: border-box;
    border-radius: 8px;
    height: 100px;
    width: 30%;
}

.league-user-permissions__permission-group__description.baloa-username{
    color: var(--basic-gray-color) !important;
}

.league-user-permissions__permission-option__title.baloa-names {
    color: var(--primary-dark-color) !important;
    margin-bottom: 3px;
}

.staff-member__registered-championships__container__championships_no_data .baloa-caption {
    margin-top: 10px;
}

.league-user-permissions__permissions-options{
    margin-top: var(--space-half-quarter);
}

.league-user-permissions__permission-option{
    margin-top: var(--space-and-half);
    display: flex;

}

.league-user-permissions__permission-option__text{
    width: 85%;
}

.league-user-permissions__permission-group__title.baloa-names{
    color: var(--primary-dark-color) !important;
}

.league-user-permissions__permission-option__description.baloa-username {
    color: var(--basic-gray-color) !important;
}

.league-user-permissions__permission-option__control{
    width: 15%;
    text-align: right;
}

.registered-championships__card__info__championships_content_text .baloa-subtitle-1{
    font-size: 20px !important;
}

.registered-championships__card__info__championships{
    display: flex;
    justify-content: space-between;
}

.league-user-permissions__save-button{
    display: flex;
    justify-content: right;
}

.league-user-permissions__save-button__button{
    margin-top: var(--space-and-half);
    margin-bottom: var(--space-and-half);
}

.staff-member__registered-championships__container__championships h6 {
    color: var(--primary-dark-color) !important;
}

.staff-member__registered-championships__container__championships ul {
    list-style-type:none;
    padding: 0;
    margin: var( --space ) 0 0 0;
}

.staff-member__registered-championships__container__championships ul li{
    padding: var(--space-half);
}

.registered-championships__card_championships {
    display: flex;
    align-items: center; 
    justify-content: space-between;   
}

.registered-championships__card__info_championships p {
    margin-bottom: var(--space-half);
}

.registered-championships__card_championships span {
    color: var( --basic-green-color );
}

.registered-championships__card__info__championships.baloa-names{
    color: var(--primary-very-dark-color) !important;
}

.registered-championships__card__info__championships.baloa-username {
    color: var(--primary-dark-color) !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-user-permissions/LeagueUserPermissionsComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,kCAAkC;IAClC,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,kCAAkC;IAClC,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,2CAA2C;AAC/C;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,wBAAwB;AAC5B;AACA;IACI,8BAA8B;IAC9B,+CAA+C;IAC/C,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,eAAe;IACf,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,0CAA0C;IAC1C,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,UAAU;AACd;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,2CAA2C;IAC3C,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,iCAAiC;IACjC,aAAa;;AAEjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;IACjC,oCAAoC;AACxC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,oBAAoB;IACpB,UAAU;IACV,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,2CAA2C;AAC/C","sourcesContent":[".league-user-permissions__sections{\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-items: center;\n    margin-top: var(--space-x2);\n}\n\n.league-user-permissions__container{\n    width: 60%;\n    background: rgba(255, 255, 255, 1);\n    border-radius: 8px;\n    padding: 1%;\n}\n\n.league-user-permissions__container__championships{\n    width: 40%;\n    background: rgba(255, 255, 255, 1);\n    border-radius: 8px;\n    padding: 1%;\n    margin-left: 1%\n}\n\n.league-user-permissions__title.baloa-subtitle-2{\n    color: var(--primary-dark-color) !important;\n}\n.league-user-permissions__permissions-groups{\n    display: flex;\n    justify-content: space-between;\n    margin-top: var(--space);\n}\n.league-user-permissions__permission-group{\n    background: var(--white-color);\n    border: 1px solid var(--disabled-sb-font-color);\n    box-sizing: border-box;\n    border-radius: 8px;\n    height: 100px;\n    width: 30%;\n    cursor: pointer;\n    padding: 7px;\n    display: grid;\n    justify-content: center;\n    align-items: start;\n}\n\n.league-user-permissions__permission-group.selected{\n    background: var(--white-color);\n    border: 2px solid var(--basic-green-color);\n    box-sizing: border-box;\n    border-radius: 8px;\n    height: 100px;\n    width: 30%;\n}\n\n.league-user-permissions__permission-group__description.baloa-username{\n    color: var(--basic-gray-color) !important;\n}\n\n.league-user-permissions__permission-option__title.baloa-names {\n    color: var(--primary-dark-color) !important;\n    margin-bottom: 3px;\n}\n\n.staff-member__registered-championships__container__championships_no_data .baloa-caption {\n    margin-top: 10px;\n}\n\n.league-user-permissions__permissions-options{\n    margin-top: var(--space-half-quarter);\n}\n\n.league-user-permissions__permission-option{\n    margin-top: var(--space-and-half);\n    display: flex;\n\n}\n\n.league-user-permissions__permission-option__text{\n    width: 85%;\n}\n\n.league-user-permissions__permission-group__title.baloa-names{\n    color: var(--primary-dark-color) !important;\n}\n\n.league-user-permissions__permission-option__description.baloa-username {\n    color: var(--basic-gray-color) !important;\n}\n\n.league-user-permissions__permission-option__control{\n    width: 15%;\n    text-align: right;\n}\n\n.registered-championships__card__info__championships_content_text .baloa-subtitle-1{\n    font-size: 20px !important;\n}\n\n.registered-championships__card__info__championships{\n    display: flex;\n    justify-content: space-between;\n}\n\n.league-user-permissions__save-button{\n    display: flex;\n    justify-content: right;\n}\n\n.league-user-permissions__save-button__button{\n    margin-top: var(--space-and-half);\n    margin-bottom: var(--space-and-half);\n}\n\n.staff-member__registered-championships__container__championships h6 {\n    color: var(--primary-dark-color) !important;\n}\n\n.staff-member__registered-championships__container__championships ul {\n    list-style-type:none;\n    padding: 0;\n    margin: var( --space ) 0 0 0;\n}\n\n.staff-member__registered-championships__container__championships ul li{\n    padding: var(--space-half);\n}\n\n.registered-championships__card_championships {\n    display: flex;\n    align-items: center; \n    justify-content: space-between;   \n}\n\n.registered-championships__card__info_championships p {\n    margin-bottom: var(--space-half);\n}\n\n.registered-championships__card_championships span {\n    color: var( --basic-green-color );\n}\n\n.registered-championships__card__info__championships.baloa-names{\n    color: var(--primary-very-dark-color) !important;\n}\n\n.registered-championships__card__info__championships.baloa-username {\n    color: var(--primary-dark-color) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
